import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import isBefore from "date-fns/isBefore";
import ExposantValue from "../../../fdes/components/ExposantValue";
import { useRef } from "react";
import CustomTooltip from "../../../../common/components/CustomTooltip";
import { isEllipsisActive } from "../../../../utils";

export const CalculTableRows = ({
  calculsColumns,
  calcul,
  openCalcul,
  isFinished,
  isArchivesFolder = false,
}) => {
  const columns = [];
  const nameRef = useRef();
  const folderRef = useRef();

  const handleOpenCalcul = (e) => {
    e.stopPropagation();
    openCalcul();
  };

  (calculsColumns || []).forEach((column) => {
    if (!column.active) return;
    if (isArchivesFolder && column.value === "folders") return;
    switch (column.value) {
      case "name":
        columns.push(
          <td
            key={`row-${column.value}-${calcul._id}`}
            className="text-interaction calcul-name-column"
            ref={nameRef}
            data-toggle="dropdown"
            data-tooltip-id={`name-${calcul._id}`}
            onMouseEnter={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {calcul &&
              calcul.reports &&
              calcul.reports.createdAt &&
              calcul.model &&
              calcul.model.reportReferenceUpdatedAt &&
              isBefore(
                parseISO(calcul.reports.createdAt),
                parseISO(calcul.model.reportReferenceUpdatedAt),
              ) && (
                <>
                  <i
                    className="feather icon-alert-triangle warning lighten-2 mr-1"
                    data-tooltip-id={`alert${calcul._id}`}
                  />
                  <CustomTooltip id={`alert${calcul._id}`} place="top">
                    <div className="text">
                      Une mise à jour des modèles d’export a été effectuée,
                      cette mise a jour est sans impact sur les résultats de
                      votre calcul.
                    </div>
                  </CustomTooltip>
                </>
              )}
            {calcul && calcul.model && !calcul.model.active && (
              <>
                <i
                  data-tooltip-id={`maintenance${calcul._id}`}
                  className="feather icon-alert-triangle danger darken-4 mr-1"
                />
                <CustomTooltip id={`maintenance${calcul._id}`} place="top">
                  <div className="text">
                    {calcul?.isCompatible
                      ? "Une mise à jour du modèles de calcul a été effectuée, cette mise à jour a un impact sur les résultats de votre calcul. Vous ne pouvez plus modifier ce calcul. Si vous souhaitez recalculer les résultats de votre calcul avec la nouvelle version de calcul, veuillez créer un nouveau calcul."
                      : "Calcul non duplicable réalisé avec un ancien modèle de calcul non compatible avec l’actuel."}
                  </div>
                </CustomTooltip>
              </>
            )}

            <span className="calcul-name" onClick={handleOpenCalcul}>
              {calcul.title}
            </span>
            {isEllipsisActive(nameRef) && (
              <CustomTooltip
                id={`name-${calcul._id}`}
                place="bottom"
                dark
                offset={-10}
              >
                <div className="text">{calcul.title}</div>
              </CustomTooltip>
            )}
          </td>,
        );
        break;
      case "status":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {isFinished ? (
              <div className="status-badge finalized">Finalisé</div>
            ) : (
              <div className="status-badge in-progress">En cours</div>
            )}
          </td>,
        );
        break;
      case "result":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {calcul.metrics &&
            (calcul.metrics.referenceValue ||
              calcul.metrics.totalGlobalWarming) ? (
              calcul.metrics.referenceValue ? (
                <ExposantValue
                  value={calcul.metrics.referenceValue}
                  unit={calcul.metrics.referenceUnit}
                  forceLiteral
                />
              ) : (
                <ExposantValue
                  value={calcul.metrics.totalGlobalWarming}
                  unit="kg eq. CO2"
                  forceLiteral
                />
              )
            ) : (
              "0"
            )}
          </td>,
        );
        break;
      case "folders":
        columns.push(
          <td
            key={`row-${column.value}-${calcul._id}`}
            className="folder-name-column"
            ref={folderRef}
            data-toggle="dropdown"
            data-tooltip-id={`folder-${calcul._id}`}
            onMouseEnter={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {calcul.folders?.length === 1 && (
              <>
                <span>{calcul.folders[0].label}</span>
                {isEllipsisActive(folderRef) && (
                  <CustomTooltip
                    id={`folder-${calcul._id}`}
                    place="bottom"
                    dark
                    offset={-10}
                  >
                    <div className="text">{calcul.folders[0].label}</div>
                  </CustomTooltip>
                )}
              </>
            )}
            {calcul.folders?.length > 1 && (
              <>
                <span
                  data-toggle="dropdown"
                  data-tooltip-id={`details-${calcul._id}`}
                  className="folders-details"
                  onClick={(e) => e.stopPropagation()}
                  onMouseEnter={(e) => e.stopPropagation()}
                >
                  Détails
                </span>
                <CustomTooltip id={`details-${calcul._id}`} place="bottom" dark>
                  <div className="labels-list">
                    Calcul ajouté à :
                    <ul>
                      {[...calcul.folders]
                        .sort((a, b) => a.label?.localeCompare(b.label))
                        .map((folder) => (
                          <li key={calcul._id + folder._id}>{folder.label}</li>
                        ))}
                    </ul>
                  </div>
                </CustomTooltip>
              </>
            )}
          </td>,
        );
        break;
      case "projectName":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>{calcul.project}</td>,
        );
        break;
      case "productFamily":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {calcul?.model?.productFamily?.shortLabel ||
              calcul?.model?.productFamily?.label ||
              ""}
          </td>,
        );
        break;
      case "version":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {calcul.model && calcul.model.version ? calcul.model.version : ""}
          </td>,
        );
        break;
      case "createdAt":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {format(parseISO(calcul.createdAt), "dd/MM/yyyy HH:mm")}
          </td>,
        );
        break;
      case "updatedAt":
        columns.push(
          <td key={`row-${column.value}-${calcul._id}`}>
            {format(parseISO(calcul.updatedAt), "dd/MM/yyyy HH:mm")}
          </td>,
        );
        break;
      default:
        break;
    }
  });

  return columns;
};
